import React, { useId, useState } from "react";
import {
  AvatarPlaceholder,
  AvatarPlaceholders,
  Camera,
  ProfileImg,
} from "../../../../components/styled/AllImages";
import { Box } from "../../../../components/styled/Elements";
import styled from "styled-components";
import { useUser } from "../../../../context/userContext";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";

const ProfileImageUpload = ({ handleImageUpload, cameraImage }) => {
  const { user } = useUser();
  const [profileImage, setProfileImage] = useState(
    user?.profile ? resolveMediaUrl(user?.profile) : AvatarPlaceholder
  );
  const uniqueId = useId();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleImageUpload({ profile: file });
      const fileURL = URL.createObjectURL(file);
      setProfileImage(fileURL);
    }
  };

  return (
    <Box className="profileAvatarImgContainer">
      <img className="profileAvatar" src={profileImage} />
      {cameraImage && (
        <Box
          className="profileCamera cursor-pointer"
          onClick={() =>
            document.getElementById(`imageInput-${uniqueId}`).click()
          }
        >
          <Camera />
        </Box>
      )}
      <input
        id={`imageInput-${uniqueId}`} // Use the unique ID here
        type="file"
        accept="image/png, image/jpeg, image/jpg" // Accept only image files
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </Box>
  );
};
export default ProfileImageUpload;
